import { SxProps } from '@mui/material';
import { green, red, yellow } from '@mui/material/colors';
import { Stack } from 'shared/mui/Stack/Stack';
import { TableRow } from 'shared/mui/Table';

import {
  ColorMarker,
  TableCellHeaderStyled,
  TableCellStyled,
} from './OrderConversionListOrdersTableRow.styled';

const STATUS_COLORS = {
  success: green[300],
  pending: yellow[600],
  failure: red[400],
};

type Props = {
  label: string;
  value: number;
  headerStyle?: SxProps;
  contentStyle?: SxProps;
  status?: keyof typeof STATUS_COLORS;
};

export const OrderConversionListOrdersTableRow: React.FC<Props> = ({
  label,
  value,
  headerStyle,
  contentStyle,
  status,
}) => {
  return (
    <TableRow>
      <TableCellHeaderStyled
        label={
          status ? (
            <Stack alignItems="center" direction="row" gap="4px">
              <ColorMarker style={{ backgroundColor: STATUS_COLORS[status] }} />
              {`${label}:`}
            </Stack>
          ) : (
            `${label}:`
          )
        }
        sx={headerStyle}
      />
      <TableCellStyled component="th" scope="row" sx={contentStyle}>
        {value}
      </TableCellStyled>
    </TableRow>
  );
};
